import axios from 'axios';
import { meiliAxios } from '../../common/meiliAxios';
import { createURLSearchParams } from '../../../utils/creator/createURLSearchParams.util';
import { IMeilisearchResponse } from '../../../interfaces/Element.interfaces';
import { IBrand } from '../../../interfaces/Brand.interfaces';
import { IMachine } from '../../../interfaces/Machine.interfaces';

export interface IGetMachineSearchParams {
  q: string;
  filter: string;
}

interface IMachinePriceStatisticsMachine extends Omit<IMachine, 'horsePower' | 'rowConfig' | 'brand' | 'images'> {
  imageBack: string | null;
  imageLeft: string | null;
  imageFront: string | null;
  imageRight: string | null;
  engineOutputInHp: number | null;
}

interface IMachinePriceStatisticsSearchData {
  id: string;
  brand: IBrand;
  machine: IMachinePriceStatisticsMachine;
  brandName: string;
  model: string;
  modelImage: string | null;
  priceStatistics: {
    id: string;
    maxPrice: number;
    minPrice: number;
    priceCount: number;
    medianPrice: number;
    registeredAt: string;
  } | null;
}

export interface IUseGetMachineSearchDataReturn extends IMeilisearchResponse {
  hits: IMachinePriceStatisticsSearchData[];
}

export const getMachineSearchData = (searchParam: IGetMachineSearchParams): Promise<IUseGetMachineSearchDataReturn> => {
  const urlSearchParams = createURLSearchParams(searchParam);

  const indexUid = (() => {
    switch (process.env.REACT_APP_CLIENT_ENVIRONMENT) {
      case 'production':
        return 'market_machine';
      case 'staging':
        return 'market_machine_stage';
      default:
        return 'market_machine_dev';
    }
  })();

  return meiliAxios.get(`/indexes/${indexUid}/search?${urlSearchParams}`);
};
